import TomSelect        from 'tom-select';

export class NormalSeasonDropdown {
	constructor (  $container)
	{
		this.$container = $container;

		this.$seasonSwitcher = this.$container.querySelector( '.season-selector .seasons-dropdown' );

		console.log('this.$seasonSwitcher', this.$seasonSwitcher);

		this.setupPrettyDropdown();

		this.bindEvents();

	}


	bindEvents(){
		this.$seasonSwitcher.addEventListener( 'change', ( event ) =>
		{
			window.location = this.$seasonSwitcher.value;
		} );
	}

	setupPrettyDropdown ()
	{
		// https://tom-select.js.org/docs/#controlinput

		this.dropdownSettings     = {
			controlInput : false,
		}
		this.prettySelectInstance = new TomSelect( this.$seasonSwitcher, this.dropdownSettings );
	}
}

const $allDropdowns = document.querySelectorAll( '.season-selector.no-map' );

if ( $allDropdowns.length > 0 )
{
	$allDropdowns.forEach( ( el, i ) =>
	{
		const normalSeasonDropdown = new NormalSeasonDropdown( el );
	} );
}